// extracted by mini-css-extract-plugin
export var box = "_40-2";
export var checkboxControl = "_40-0";
export var checkboxRow = "_40-9";
export var checked = "_40-3";
export var descriptionSpacer = "_40-b";
export var disabled = "_40-4";
export var icon = "_40-7";
export var input = "_40-1";
export var labelSpacer = "_40-a";
export var medium = "_40-6";
export var small = "_40-5";
export var text = "_40-8";